module.exports = __webpack_public_path__ + "img/step4-en.aa116a54.png";